<script setup lang="ts">
  import { useAppHeaderTabs } from "./useAppHeaderTabs";

  const { tabsConfig } = useAppHeaderTabs();
</script>

<template>
  <nav
    v-if="tabsConfig"
    class="flex h-full items-center gap-1"
    aria-label="Page views">
    <button
      v-for="tab in tabsConfig.tabs"
      :key="tab.value"
      type="button"
      role="tab"
      :aria-selected="tabsConfig.value === tab.value"
      class="relative flex items-center gap-1.5 px-3 py-1 text-13 font-medium transition-colors after:absolute after:inset-x-3 after:-bottom-1.5 after:h-0.5 after:rounded-full after:transition-colors"
      :class="
        tabsConfig.value === tab.value
          ? 'text-primary after:bg-ring'
          : 'text-muted-foreground hover:text-primary after:bg-transparent'
      "
      @click="tabsConfig.setValue(tab.value)">
      <component
        :is="tab.icon"
        class="size-4"
        :stroke-width="1.8" />
      <span>{{ tab.label }}</span>
    </button>
  </nav>
</template>
